var _style, _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "15.5px",
    height: "15.5px",
    viewBox: "0 0 15.5 15.5",
    style: {
      enableBackground: "new 0 0 15.5 15.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FEE565;}\n\t.st1{fill:#FDD62F;}\n\t.st2{fill:#1D1D1D;}\n\t.st3{fill:#F37E7F;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 7.7517633,
    cy: 7.7515717,
    r: 7.7490001
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.3492732,8.4294205c0,2.3800049,0.9799805,4.5200195,2.5699463,6.0599976 c-2.3399658-1.3300171-3.9199829-3.8499756-3.9199829-6.7399902c0-4.2800293,3.4700317-7.75,7.75-7.75 c0.3400273,0,0.6699834,0.0200195,0.9899907,0.0700073C4.5692439,0.5794449,1.3492732,4.1294327,1.3492732,8.4294205z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.25,4.5c-0.7440004,0-1.6470003,0.9160004-1.75,2.2309999 C8.4887438,6.8680573,8.5907259,6.9882898,8.7277832,6.9995461c0.0975752,0.0080128,0.1907911-0.0418968,0.2382164-0.1275463 l0.3000002-0.5310001C9.4458199,5.9529324,9.8232155,5.6940479,10.25,5.6659994 c0.4267845,0.0280485,0.8041801,0.2869329,0.9840002,0.6750002l0.3000002,0.5310001 c0.0666161,0.120307,0.2181463,0.1638327,0.3384533,0.0972166C11.9581041,6.9217901,12.0080137,6.8285751,12,6.7309999 C11.8999996,5.4160004,10.9940004,4.5,10.25,4.5z M3.9690001,6.8719997l0.3-0.5310001 c0.1798205-0.3880672,0.5572157-0.6469517,0.9840002-0.6750002c0.4267845,0.0280485,0.8041797,0.2869329,0.9840002,0.6750002 l0.3000002,0.5310001c0.0699172,0.1184187,0.2225938,0.1577368,0.3410125,0.0878201 C6.9583158,6.9124069,7.0053945,6.8240986,7,6.7309999C6.9000001,5.415,5.994,4.5,5.25,4.5S3.5999999,5.4160004,3.5,6.7309999 C3.4916592,6.8704786,3.5979674,6.9903107,3.7374463,6.9986515C3.8333347,7.004385,3.9241991,6.9553213,3.9720001,6.8719997 H3.9690001z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11.3249998,8.75H4.1750002c-0.2313836-0.0033131-0.421643,0.1815739-0.4249561,0.4129581 C3.7497759,9.1816845,3.7507637,9.200407,3.7530003,9.2189999C4.0103421,11.1083221,5.6302772,12.5129204,7.5370002,12.5h0.4250002 c1.9067235,0.0129204,3.5266576-1.3916779,3.7839999-3.2810001c0.0276375-0.2297516-0.1362076-0.438406-0.3659582-0.4660435 C11.3614483,8.7507191,11.3427258,8.7497311,11.3240004,8.75H11.3249998z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.af642498aaec2fc1b2af885a60575960.svg";
export { ForwardRef as ReactComponent };